import React from 'react'
import Layout from '../../components/Layout/Layout'
import ErrorMessage from '../../components/UI/Notifications/ErrorMessage'
import Button from '../../components/UI/Buttons/Button'
import { useForm } from 'react-hook-form'
import { useSelector } from 'react-redux'
import SelectDropdown from '../../components/UI/Forms/SelectDropdown'
import Textarea from '../../components/UI/Forms/Textarea'
import { callApi } from '../../api/callApi'
import { API_ENDPOINT, API_URL_2 } from '../../api/constant'
import { showToastNotification } from '../../utility/helper'

interface NotificationForm {
    roleId: string;
    message: string;
}

const Notifications: React.FC = () => {
    const { register, handleSubmit, formState: { errors }, reset } = useForm<NotificationForm>({ mode: 'onBlur' });
    const [loadingButton, setLoadingButton] = React.useState<boolean>(false);
    const roles = useSelector((state: any) => state.root.roles)

    const onSubmit = async (data: NotificationForm) => {
        setLoadingButton(true);
        let postData = {
            "notification": {
                "roleId": data.roleId,
                "message": data.message,
                "body": {
                    "screen": "",
                    "data": {
                        "id": "",
                        "type": "",
                        "userId": ""
                    }
                }
            }
        }
        try {
            await callApi(API_URL_2 + API_ENDPOINT.auth + 'notification/push-to-many', { method: 'POST', data: postData });
            showToastNotification('success', 'Notification sent successfully');
            reset()
        } catch (error: any) {
            showToastNotification('danger', error?.message || 'Failed to send notification');
            console.error('Failed to send notification:', error.message);
        } finally {
            setLoadingButton(false);
        }
    };
    return (
        <Layout>
            <div className='app-page-title'>Notification Center</div>
            <div className='row'>
                <div className="col-lg-12">
                    <div className="app-card app-card-settings shadow-sm p-4">
                        <div className="app-card-body">
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="row">
                                    <div className="mb-3 col-12">
                                        <SelectDropdown
                                            register={register('roleId', { required: 'User Base is required' })}
                                            name="roleId"
                                            label="User Base"
                                            options={roles.map((role: any) => ({ label: role.name, value: role.id }))}
                                        />
                                        <ErrorMessage message={errors.roleId?.message} />
                                    </div>
                                    <div className="mb-3 col-12">
                                        <Textarea
                                            register={register('message', { required: 'Notification is required' })}
                                            name="message"
                                            label="Notification"
                                            placeholder="Enter Notification Message"
                                        />
                                        <ErrorMessage message={errors.message?.message} />
                                    </div>
                                </div>
                                <div className="col-12 text-end mt-3 ">
                                    <Button loading={loadingButton} className="btn btn-primary text-white px-5" type="submit" text={'Send Notification'} />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default Notifications